import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center gap-3 text-center animate-slideFadeIn" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-red-600 bg-red-100 px-3 py-2 rounded-lg w-full"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "mb-4"
}

import { computed, onBeforeUnmount, ref } from "vue"
import { useStore } from "vuex"
import axios from "@/services/api"
import { getConfigValue } from "@/core/config"
import mixpanel from "mixpanel-browser"
import router from "@/router"
import { clearOnboardingToken, getOnboardingToken, getSignupRole, getUserEmail } from "@/lib/signupVault"


export default /*@__PURE__*/_defineComponent({
  __name: 'DoneStep',
  props: {
    canGoBack: { type: Boolean }
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit


const store = useStore()
const loading = ref(false)
const errorMessage = ref("")
const accountCompleted = ref(false)
const stepMessage = ref("Creating your account...")
const selectedLanguage = computed(() => store.state.stepper.selectedLanguage)

const finish = async () => {
    loading.value = true
    errorMessage.value = ""
    stepMessage.value = "Creating your account..."

    const onboardingToken = getOnboardingToken()
    const role = getSignupRole()
    const email = getUserEmail()
    if (!onboardingToken) {
        loading.value = false
        errorMessage.value = "Session expired. Please start again."
        router.push(`/auth/signup/${role || 'creator'}`)
        return
    }
    const payload = {
        ...store.state.authOnboarding,
        email: email,
        selectedLanguage: selectedLanguage.value,

    }
    if (role !== "creator") {
        loading.value = false
        return
    }

    try {
        let profile = "TALENT"
        const res = await axios.post("user/signup", {
            ...payload,
            profile,
            allowAutoSignin: true,
            onboardingToken,

        })
        if (res.status === 200) {
            stepMessage.value = "Setting up your dashboard..."
            const createdId = res.data.created_user_id
            const loginData = res.data.loginData
            if (process.env.VUE_APP_NODE_ENV === "production") {
                mixpanel.track('[REGISTER-PAGE] Sign Up', {
                    label: '[REGISTER-PAGE] Sign Up',
                    page: window.location.pathname
                });
            }

            try {
                const fieldsRes = await axios.post(
                    "/profile-fields/by-names",
                    {
                        fields: [
                            "influencer_email",
                            "phone_prefix",
                            "phone",
                            "ig_username",
                            "tiktok_username",
                        ],
                    }
                )

                const dynamicFields = fieldsRes.data.data || []

                const values = dynamicFields.map((field: any) => {
                    let value = ""

                    switch (field.name) {
                        case "influencer_email":
                            value = email || ""
                            break
                        case "phone_prefix":
                            value = payload.phone_prefix
                            break
                        case "phone":
                            value = payload.phone
                            break
                        case "ig_username":
                            value = payload.ig_username
                            break
                        case "tiktok_username":
                            value = payload.tiktok_username
                            break
                    }

                    return {
                        field_id: field.field_id,
                        value,
                    }
                }).filter((v: any) => v.value)
                if (values.length > 0) {
                    await axios.post("/profile-influencer/fields/save", {
                        values,
                        signup: true,
                        requested_influencer_id: createdId

                    })
                }

                const redirectUrl =
                    loginData?.redirectionUrl ||
                    `${getConfigValue('DASHBOARD_DOMAINE')}?token=${loginData.token}&selectedLanguage=${loginData.selectedLanguage}`
                clearOnboardingToken()
                loading.value = false
                window.location.href = redirectUrl

            } catch (loginError: any) {
                clearOnboardingToken()
                loading.value = false
                accountCompleted.value = true
                errorMessage.value = "Something went wrong. Please try again later."
            }
        }

    } catch (e: any) {
        clearOnboardingToken()
        loading.value = false
        errorMessage.value = e.response?.data?.message || "Something went wrong. Please try again."

    }
}

const handleUnload = () => clearOnboardingToken()
window.addEventListener('beforeunload', handleUnload)
onBeforeUnmount(() => {
    clearOnboardingToken()
    window.removeEventListener('beforeunload', handleUnload)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-2xl font-semibold text-gray-600" }, " You’re all set! ", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-gray-400" }, " Your account is ready. We’re finishing up the final touches so you can get started. ", -1)),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (!accountCompleted.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!accountCompleted.value ? finish() : _unref(router).push('/auth/signin'))),
          disabled: loading.value,
          class: "w-[95%] lg:w-[75%] mt-8 bg-gradient-to-r from-purple-500 to-pink-400 text-white font-semibold py-3 rounded-xl flex justify-center"
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(stepMessage.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "Join TAWA"))
        ], 8, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.canGoBack && !accountCompleted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('back'))),
            class: "flex items-center gap-2 text-sm text-gray-500 hover:text-purple-500 hover:underline transition"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "Go Back", -1)
          ]))])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})